import React, { Fragment } from "react";
import { useSelector } from "react-redux";

import LoadingIcon from "src/asset/modal/ic_loading_animation_v2.svg";
import styles from "./styles.module.scss";
import { SpinnerSelectors } from "src/redux/Spinner/selectors";

const Spinner = (props) => {
    const isOpen = useSelector(SpinnerSelectors.IsOpen);

    if (!isOpen) return null;

    return (
        <Fragment>
            <div
                className={styles.loader}
                data-testid="truweb-fullscreen-loader"
            >
                <img
                    src={LoadingIcon}
                    className={styles.spinner_img}
                    alt="loading"
                />
            </div>
        </Fragment>
    );
};

export default Spinner;
